import { render, staticRenderFns } from "./datatable-detail.vue?vue&type=template&id=68a3bc06&scoped=true"
import script from "./datatable-detail.vue?vue&type=script&lang=js"
export * from "./datatable-detail.vue?vue&type=script&lang=js"
import style0 from "./datatable-detail.vue?vue&type=style&index=0&id=68a3bc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3bc06",
  null
  
)

export default component.exports